if (typeof homeCategory !== 'function') {
    class homeCategory extends HTMLElement {
        constructor() {
            super();
            this.holderCategories = this.querySelector('[data-categories-holder]');
            this.screenWidth = window.innerWidth;
            this.resizeObserver = new ResizeObserver(() => this.handleResize());
        }

        connectedCallback() {
            this.categorieItem = [...this.querySelectorAll('[data-category-item]')];
            if (this.categorieItem.length) {
                this.init();
                this.resizeObserver.observe(document.body);
            }
        }

        disconnectedCallback() {
            this.resizeObserver.disconnect();
        }

        init() {
            this.handleResize();
        }

        handleResize() {
            const isMobile = window.innerWidth <= 768;
            if (isMobile && !this.querySelector('.categories-outer')) {
                this.groupCategories();
            } else if (!isMobile && this.querySelector('.categories-outer')) {
                this.ungroupCategories();
            }
        }

        groupCategories() {
            if (this.categorieItem.length > 2) {
                let outerContainer = document.createElement('div');
                outerContainer.classList.add('categories-outer');

                let innerContainer = document.createElement('div');
                innerContainer.classList.add('categories-inner');

                for (let i = 2; i < this.categorieItem.length; i++) {
                    innerContainer.appendChild(this.categorieItem[i]);
                }

                outerContainer.appendChild(innerContainer);
                this.categorieItem[1].after(outerContainer);
            }
        }

        ungroupCategories() {
            let outerContainer = this.querySelector('.categories-outer');
            if (outerContainer) {
                let innerContainer = outerContainer.querySelector('.categories-inner');
                if (innerContainer) {
                    while (innerContainer.firstChild) {
                        this.holderCategories.appendChild(innerContainer.firstChild);
                    }
                }
                outerContainer.remove();
            }
        }
    }

    if (typeof customElements.get('adrnl-category-home') === 'undefined') {
        customElements.define('adrnl-category-home', homeCategory);
    }
}
